import React from 'react'
import $ from 'jquery'
import Accordion from 'react-bootstrap/Accordion'
import Card from 'react-bootstrap/Card'
import Listitem from './listitem'


class ListLoad extends React.Component {
    
    constructor(props) {
        super(props);
        this.sortItem = this.sortItem.bind(this);
        this.uaCheck = this.uaCheck.bind(this);
        this.state = {
            data:Object,
            itemData:[],
            ua: 'pc',
            loadItem: ""
        };
    }
    
    uaCheck(){
        var ua = navigator.userAgent.toLowerCase();
        let flg = "";
        if( ua.indexOf('iphone') > -1 || ua.indexOf('ipad') > -1){
            flg = 'ios';
        }else if( ua.indexOf('android') > -1){
            flg = 'android';
        }
        this.setState({ ua: flg });
    }

    sortItem (data){
        var newLine = data;
        this.setState({ itemData: newLine });
    }

    componentDidMount () {

        $.ajax({
            url: this.props.url,
            dataType: 'json',
            cache: false,
            success: function(data) {
                this.setState({data: data});
            }.bind(this),
            error: function(xhr, status, err) {
              console.log(this.props.url, status, err.toString());
            }.bind(this)
          });

        this.sortItem(this.state.data);
        this.uaCheck();
    }
    
render () {

        var object = this.state.data;
        let _ua = this.state.ua;
        let itemsNodes = Object.keys(object).map(function(item,i){

            let items = object[item].map(function(_item,_i){
                return(
                    <Listitem
                    key={'c'+i+_i}
                    title={ _item.name }
                    glb={ _item.glb }
                    usdz={_item.usdz}
                    ua={_ua}/>
                )
            });
            
            return(
                <Card key={'o'+i} style={{backgroundColor:"unset"}}>
                    <Card.Header>
                        <Accordion.Toggle className="card-header-btn" variant="link" eventKey={i+1}>
                            {item}
                            </Accordion.Toggle>
                            </Card.Header>
                            <Accordion.Collapse eventKey={i+1}>
                                <Card.Body>
                                    {items}
                                </Card.Body>
                            </Accordion.Collapse>
                </Card>
                
            );
        })
    
return (
        <div className={'no-gutters serviceLinks'} style={{width: '100%', margin:'0 auto', padding:'0 1em'}} >
            <Accordion defaultActiveKey="1">
                {itemsNodes}
                {this.state.loadItem}
            </Accordion>
        </div>
    
)

  }
  

    
}

export default ListLoad